export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11480.4bd106fd.jpg";